export default {"src":"/_next/static/media/QGEN.5ec43d3a.svg","height":18,"width":18};